import { Link } from "gatsby"
import Img from "gatsby-image"
import React from "react"
import styled from "styled-components"
import { H5, P } from "styleguide/components/Text"
import { MetaTags } from "styleguide/page-components/Blog"
import { uiColorToBaseColor } from "styleguide/styles/colors"
import media from "styleguide/styles/media-queries"

interface Props {
  featuredImage: any
  title: string
  author: string
  date: string
  slug: string
  excerpt: string
  categories: string[]
}

const StyledH3 = styled(H5)`
  margin: 0 0 8px 0;
  color: ${uiColorToBaseColor("darkestGray")};
`

const RoundImg = styled(Img)`
  border-radius: 8px;
  margin-bottom: 16px;
`

const StyledP = styled(P)`
  font-size: 16px;
  line-height: 24px;
  margin-top: 0;
  margin-bottom: 12px;
  color: ${uiColorToBaseColor("darkestGray")};

  ${media.tablet`
  font-size:14px;
  `}
`

const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`

const BlogTile = ({
  title,
  featuredImage,
  author,
  date,
  slug,
  categories,
  excerpt,
}: Props) => (
  <div>
    <StyledLink to={slug}>
      {featuredImage && (
        <RoundImg fluid={featuredImage.childImageSharp.fluid} />
      )}
      <StyledH3>{title}</StyledH3>
    </StyledLink>
    <StyledP>{excerpt}</StyledP>
    <MetaTags categories={categories} author={author} date={date} />
  </div>
)

export default BlogTile
